var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeModule } from "./NativeModule";
import { NativeInterface } from "./NativeInterface";
var TcpSocketWrapper = /** @class */ (function () {
    function TcpSocketWrapper(socketNative, id) {
        this.connected = true;
        this.onClose = null;
        this.socketNative = socketNative;
        this.id = id;
        SocketNative.registerTcpWrapper(this);
    }
    TcpSocketWrapper.prototype.read = function (length) {
        if (length === void 0) { length = -1; }
        return this.socketNative.tcpRead(this.id, length);
    };
    TcpSocketWrapper.prototype.send = function (bytes, flush) {
        if (flush === void 0) { flush = true; }
        return this.socketNative.tcpSend(this.id, bytes, flush);
    };
    TcpSocketWrapper.prototype.close = function () {
        this.connected = false;
        return this.socketNative.tcpClose(this.id);
    };
    TcpSocketWrapper.prototype.getId = function () {
        return this.id;
    };
    TcpSocketWrapper.prototype.isConnected = function () {
        return this.connected;
    };
    TcpSocketWrapper.prototype.setConnected = function (status) {
        return this.connected = status;
    };
    return TcpSocketWrapper;
}());
export { TcpSocketWrapper };
var SocketNative = /** @class */ (function (_super) {
    __extends(SocketNative, _super);
    function SocketNative() {
        var _this = _super.call(this) || this;
        NativeInterface.instance.addModule(_this);
        return _this;
    }
    SocketNative.prototype.getPrefix = function () {
        return 'socket_';
    };
    SocketNative.prototype.tcpConnect = function (host, port) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tcp_connect',
            params: {
                host: host,
                port: port,
            }
        }).then(function (response) {
            return response.socketId;
        });
    };
    SocketNative.prototype.tcpConnectWrapper = function (host, port) {
        var _this = this;
        return this.tcpConnect(host, port).then(function (socketId) {
            return new TcpSocketWrapper(_this, socketId);
        });
    };
    SocketNative.prototype.tcpSend = function (socketId, bytes, flush) {
        if (flush === void 0) { flush = true; }
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tcp_send',
            params: {
                socketId: socketId,
                flush: flush,
                bytes: bytes,
            }
        }).then(function (response) {
        });
    };
    SocketNative.prototype.tcpRead = function (socketId, length) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tcp_read',
            params: {
                socketId: socketId,
                length: length,
            }
        }).then(function (response) {
            return response.bytes;
        });
    };
    SocketNative.prototype.tcpClose = function (socketId) {
        var self = this;
        this.setClosedStatus(socketId);
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tcp_close',
            params: {
                socketId: socketId,
            }
        }).then(function (response) {
        });
    };
    SocketNative.prototype.tcpKillAll = function () {
        var self = this;
        for (var _i = 0, _a = SocketNative.tcpSockets; _i < _a.length; _i++) {
            var socket = _a[_i];
            socket.setConnected(false);
        }
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tcp_killAll',
            params: {}
        }).then(function (response) {
        });
    };
    SocketNative.prototype.tcpListAll = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'tcp_listAll',
            params: {}
        }).then(function (response) {
            return response.connections;
        });
    };
    SocketNative.prototype.onEvent = function (event) {
        if (event.name === this.getPrefix() + 'closed') {
            var params = event.params;
            for (var _i = 0, _a = SocketNative.tcpSockets; _i < _a.length; _i++) {
                var socket = _a[_i];
                if (socket.getId() === params.socketId) {
                    socket.setConnected(false);
                    if (socket.onClose)
                        socket.onClose();
                    SocketNative.unregisterTcpWrapper(socket);
                    break;
                }
            }
        }
    };
    SocketNative.registerTcpWrapper = function (wrapper) {
        var existIndex = SocketNative.tcpSockets.indexOf(wrapper);
        if (existIndex === -1) {
            SocketNative.tcpSockets.push(wrapper);
        }
    };
    SocketNative.unregisterTcpWrapper = function (wrapper) {
        var existIndex = SocketNative.tcpSockets.indexOf(wrapper);
        if (existIndex === -1) {
            SocketNative.tcpSockets.splice(existIndex, 1);
        }
    };
    SocketNative.prototype.setClosedStatus = function (socketId) {
        for (var _i = 0, _a = SocketNative.tcpSockets; _i < _a.length; _i++) {
            var socket = _a[_i];
            if (socket.getId() === socketId) {
                socket.setConnected(false);
                break;
            }
        }
    };
    SocketNative.tcpSockets = [];
    return SocketNative;
}(NativeModule));
export { SocketNative };
//# sourceMappingURL=SocketNative.js.map